import React, { PropTypes } from 'react';

// Components
import GoogleMap from 'google-map-react';
import MapControl from './MapControl';
import DocumentControl from './DocumentControl';
import DeleteRect from './DeleteRect';
// import MarkerClusterer from 'node-js-marker-clusterer';
import LightBox from '../Common/LightBox';
import Gallery from '../Common/Gallery';
import Legend from './Legend';

import { generateLayer, generatePointGallery } from '../../businessLogic/map';
import { isArrayDifferent } from '../../businessLogic/util';
import _, { difference, isEqual } from 'lodash';

import { DropTarget } from 'react-dnd';

import supercluster from 'points-cluster';
import { Marker, Cluster } from './Markers';

class Explorer extends React.Component {

	constructor(props) {
		super(props);
		this.lastFiltered = [];
		this.state = { 
			mapLoaded: false, 
			showDelete: false, 
			legendTop: 5,
			legendLeft: 335,
			isGalleryOpen: false,
			pointsToRender: [],
			clusters: [],
			map: {
				center: {
					lat: null, 
					lng: null
				},
				zoom: null
			},
			selectedGalleryPoint: {
				label: "",
				images: []
			}
		};
	}

	componentWillMount() {
		if (this.props.isGisOnly) return;
		this.props.actions.getDocuments();
		this.props.getShapes();
		this.props.getKeywords();
	}
	
	componentDidUpdate(prevProps, prevState) {
		this.showOrHideDrawingManager();

		if ( this.shouldUpdateFeaturesAndMarkers() ) {
			
			const filtered = this.getFilteredDocuments();
			
			this.processFeatureChanges(filtered);
			this.processMarkers(prevState, filtered);
		}

		this.processMapServerLayersChanges(prevProps);
	}

	shouldUpdateFeaturesAndMarkers() {
		const { explorer } = this.props;

		return this.state.mapLoaded && 
				explorer.documents.length > 0 &&
				!explorer.isFetching;
	}

	processFeatureChanges(filtered) {
		this.clearFeaturesIfNecessary(filtered);
		this.updateFeatures(filtered);
	}

	processMarkers(prevState, filtered) {
		const points = this.getPoints(filtered);
		const markerInfo = this.prepareMarkerInfo(points);
		this.updateClustersAndMarkers(prevState, markerInfo);
	}

	showOrHideDrawingManager() {
		// Check if drawingManager is defined and then hide it if any filter was selected or
		// show if that has not happened
		if ( typeof this.drawingManager !== "undefined" ) {
			if ( this.hasAnyFilter() ) this.hideDrawingManager(false);
			else if ( !this.state.showDelete ) this.showDrawingManager();
		}
	}

	getFilteredDocuments() {
		const { explorer, selectedKeywords, selectedShapes } = this.props;

		const partialFiltered = this.filterDocuments(
			explorer.documents, selectedShapes, selectedKeywords, explorer.filter.ids);

		const filteredByProject = this.filterByProject(partialFiltered);

		return filteredByProject;
	}

	getPoints(filtered) {
		const points = [];

		// If there is any position (lat long markers) creates an array for them
		filtered.map((d) => {				
			if ( d.position.length !== 0 ) {					
				d.position.map((p) => points.push(
					{ 
						coord: { lat: parseFloat(p.lat), lng: parseFloat(p.lng) }, 
						title: d.title, 
						id: d.id, 
						type: p.type, 
						shapeId: p.shapeId,
						img: p.img,
						label: p.label
					}
				));
			}
		});

		return points;
	}

	clearFeaturesIfNecessary(filtered) {
		const { explorer } = this.props;

		if (filtered.length === explorer.documents.length) {
			let featuresInMap = [];
			
			this.google.map.data.forEach(element => {
				featuresInMap.push(element.getId());
			});
			const featuresToRemove = featuresInMap;
			featuresToRemove.map(f => {
				const feature = this.google.map.data.getFeatureById(f);
				this.google.map.data.remove(feature);
			});

			this.lastFiltered = _.cloneDeep(filtered);
		}
	}

	updateFeatures(filtered) {
		const { explorer, getGeom } = this.props;

		if (filtered.length < explorer.documents.length &&
			isArrayDifferent(filtered, this.lastFiltered)) {
			let featuresInMap = [];
			let featuresToRender = [];
			let featuresToRemove = [];
				
			this.google.map.data.forEach(element => {
				featuresInMap.push(element.getId());
			});

			filtered.map((d) => {
				d.shapes.map((s) => {
					featuresToRender.push(s);
				});
			});
			featuresToRender = _.uniq(featuresToRender);

			featuresToRemove = _.difference(featuresInMap, featuresToRender);
		
			featuresToRemove.map(f => {
				const feature = this.google.map.data.getFeatureById(f);
				this.google.map.data.remove(feature);
			});

			featuresToRender.map(f => {
				getGeom(f, this.google.map, false, 'keywords');
			});
			
			this.lastFiltered = _.cloneDeep(filtered);
		}
	}

	prepareMarkerInfo(points) {
		const newPointsToRender = [];

		// Create all markers first filtering those inside the overlay
		if (!this.props.hideDocumentsFromMap) { //toggle markers for a cleaner view
			this.filterPoints(points).map((p, i) => {

				const ClickHandler = () => {
					if ( p.type === 3 && p.img.length > 0 ) { // Only if points created with images
						// Generate image information and then open gallery
						this.setState({
							isGalleryOpen: true, 
							selectedGalleryPoint: {
								label: p.label,
								images: generatePointGallery(p.img) 
							} 
						});
					}
					this.props.actions.setExplorerSelectedDocuments(this.props.groupedDocuments[p.shapeId]);
				};

				const np = {
					...p.coord,
					type: p.type,
					docTitle: p.title,
					label: p.label,
					hasImage: p.img.length > 0,
					onClick: ClickHandler
				};
				newPointsToRender.push(np);
			});
		}

		return newPointsToRender;
	}

	updateClustersAndMarkers(prevState, newPointsToRender) {
		
		if (prevState.clusters === this.state.clusters) {
			const clustering = supercluster(
				newPointsToRender,
				{
					minZoom: 3,
					maxZoom: 14,
					radius: 60
				}
			);
			
			const mapProps = this.state.map;
			this.setState({clusters: clustering(mapProps)});
		}
	}

	processMapServerLayersChanges(prevProps) {
		const { explorer } = this.props;

		// If we changed layer, then proceed to treat it
		if ( !isEqual(prevProps.explorer.layers, explorer.layers) ) {
			if ( explorer.layers.length === 0 ) this.google.map.overlayMapTypes.clear(); // None selected
			else if ( explorer.layers.length === prevProps.explorer.layers.length ) { // We have reordered
				this.google.map.overlayMapTypes.clear(); // Clear all then add always on bottom (first should be on top)
				explorer.layers.map((l) => {
					const finalLayer = generateLayer(this.google, l);
					this.google.map.overlayMapTypes.insertAt(0, finalLayer);
				});
			} else if ( explorer.layers.length > prevProps.explorer.layers.length ) {
				const layer = explorer.layers[0]; // Added element is the first of array
				const finalLayer = generateLayer(this.google, layer);
				this.google.map.overlayMapTypes.push(finalLayer); // But we push to end to render after all others
			} else {
				const diffArray = difference(prevProps.explorer.layers, explorer.layers);
				const index = prevProps.explorer.layers.indexOf(diffArray[0]);
				const length = this.google.map.overlayMapTypes.getLength();
				this.google.map.overlayMapTypes.removeAt(length - 1 - index); // Remove but remember we had reordered
			}
		}
	}

	// If there is any overlay, only display points that are inside it
	filterPoints(points) {
		return ( typeof this.overlay !== "undefined" && this.overlay.getMap() !== null )
			? points.filter((p) => {
				const { south, west, north, east } = this.overlay.getBounds().toJSON();
				return !( p.coord.lng < west || p.coord.lng > east || p.coord.lat < south || p.coord.lat > north );
			}) : points;
	}

	hasAnyFilter() {
		const { sectors, samplingPoints, localities, keywords } = this.props.explorer.filter;
		return sectors.length > 0 || samplingPoints.length > 0 || localities.length > 0 || keywords.length > 0;
	}

	onAddShape(options) {
		if ( typeof this.google === "undefined" ) return;
		const map = this.google.map;
		options.map((o) => {
			const shape = this.props.domains.shapes.list.find((shape) => shape.id === o.value);
			this.props.getGeom(shape.id, map, false, 'explorer');			
		});
	}	

	onRemoveShape(options) {
		if ( typeof this.google === "undefined" ) return;
		const map = this.google.map;
		options.map((o) => {
			const feature = map.data.getFeatureById(o.value);
			if ( typeof feature !== "undefined" ) map.data.remove(feature);
		});
	}

	filterByProject(list) {
		var isMariana = this.props.projects.isMariana;
		var isBrumadinho = this.props.projects.isBrumadinho;
		if ( isMariana && !isBrumadinho ) {
			return this.props.projects === null ? list
					: list.filter((d) => d.projects[0] === 1);
		} else if ( !isMariana && isBrumadinho ) {
			return this.props.projects === null ? list
					: list.filter((d) => d.projects[0] === 2);
		} else if ( isMariana && isBrumadinho ) {
			return list;
		} else {
			// retorna lista vazia, uma vez que -1 nao eh uma
			// id de projeto valida
			return this.props.projects === null ? list
					: list.filter((d) => d.projects[0] === -1);

		}
	}

	filterDocuments(documents, shapes, keywords, ids) {
		if ( shapes.length === 0 && keywords.length === 0 ) {
			if ( ids === null ) return documents;
			return documents.filter((d) => ids.indexOf(d.id) > -1);
		}
		return documents.filter((d) => {
			for ( let i = 0; i < d.shapes.length; i++ ) {
				if ( shapes.indexOf(d.shapes[i]) > -1 ) return true;
			}
			for ( let i = 0; i < d.keywords.length; i++ ) {
				if ( keywords.indexOf(d.keywords[i]) > -1 ) return true;
			}
			return false;
		});
	}

	removeOverlay() {
		this.props.actions.setIds(null);
		if ( typeof this.overlay !== "undefined" ) {
			this.overlay.setMap(null); // Removes overlay (rectangle)
			this.drawingManager.setMap(this.google.map); // Shows control again
			this.drawingManager.setDrawingMode(null); // Reverts control to hand
			this.setState({showDelete: false}); // Triggers re-render
		}
	}

	hideDrawingManager(showDelete = true) {
		this.drawingManager.setMap(null);
		if ( showDelete && !this.state.showDelete ) this.setState({showDelete: true});
	}

	showDrawingManager() {
		this.drawingManager.setMap(this.google.map);
		if ( this.state.showDelete ) this.setState({showDelete: false});
	}

	moveLegend(left, top) {
		this.setState({legendTop: top, legendLeft: left});
	}

	zoomToLayer(bounds) {
		this.google.map.fitBounds(bounds);
	}

	onMapChange(changeEventValue) {
		this.setState({map: changeEventValue});
	}

	onClickCluster(map, lng, lat) {
		map.panTo({lat: lat, lng: lng});
		map.setZoom(map.zoom += 2);
	}

	renderGallery() {
		const { isGalleryOpen, selectedGalleryPoint } = this.state;
		const { label, images } = selectedGalleryPoint;

		const style = {
			content: {
				width: "800px",
				height: "600px",
				padding: '0',
				paddingBottom: "0"
			}
		};

		return (
			<LightBox 
				isOpen={isGalleryOpen} 
				onClose={() => this.setState({isGalleryOpen: false})}
				style={style}
				autocenter
			>
				<Gallery label={label} images={images} />					
			</LightBox>
		);
	}

	render () {
		const { actions, domains, explorer, groupedShapes, 
			selectedShapes, selectedKeywords, connectDropTarget } = this.props;
		const { clusters } = this.state;

		return connectDropTarget(			
			<div className='explorer' 
				style={{width: "100%", height: "90vh", margin: "0px", position: "absolute", left: "0px"}}>
				<GoogleMap
					bootstrapURLKeys={
					{
						key: "AIzaSyA7pbCrlAlFUZLlWPSriQWUIYUk8__7JLM",
						language: 'pt-BR',
						libraries: ['drawing'].join(',')
					}
					}												
					defaultCenter={{lat: -20.049293182101255, lng: -42.82365408697386}}
					options={{streetViewControl: false, mapTypeId: 'satellite'}}
					defaultZoom={7}
					onChange={(changeEventValue => this.onMapChange(changeEventValue))}
					yesIWantToUseGoogleMapApiInternals
					onGoogleApiLoaded={(google) => {
						this.google = google;
						this.setState({mapLoaded: true});

						const m = "Houve um problema ao carregar o Google Maps. Deseja atualizar a página?";
						if ( typeof google.maps.drawing === "undefined" && confirm(m) ) location.reload();

						this.drawingManager = new google.maps.drawing.DrawingManager({							
							drawingControl: true,
							drawingControlOptions: {
								position: google.maps.ControlPosition.TOP_CENTER,
								drawingModes: [google.maps.drawing.OverlayType.RECTANGLE]
							}
						});
						this.drawingManager.setMap(google.map);
						google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (e) => {							
							const json = e.overlay.getBounds().toJSON();
							//Não remover, usado para obter os bounds em DEV
							if (process.env.NODE_ENV !== "production") {
								console.warn(json);
							}
							const rect = { nw: { lat: json.north, lng: json.west }, se: { lat: json.south, lng: json.east } };
							this.props.actions.getDocumentsInArea({coordinate: rect});
							this.overlay = e.overlay;
							this.hideDrawingManager();
						}); 

						google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', () => {
							this.setState({selectedRectangle: this.drawingManager.drawingMode === "rectangle"});
						}); 
					}}
				>
					{
						clusters
							.map((cluster, id) => (
							cluster.numPoints === 1
								? <Marker key={id} lng={cluster.x} lat={cluster.y} 
											point={cluster.points[0]} zoom={this.google.map.zoom} />
								: <Cluster key={id} lng={cluster.x} lat={cluster.y} 
											allClusters={clusters} numPoints={cluster.numPoints}
											onClick={() => this.onClickCluster(this.google.map, cluster.x, cluster.y)} />
							))
					}
				</GoogleMap>
				{this.state.mapLoaded && !this.state.selectedRectangle
					? <MapControl
						onAddShape={this.onAddShape.bind(this)}
						onRemoveShape={this.onRemoveShape.bind(this)}
						shapes={groupedShapes.predefined} 
						setSectors={actions.setSectors}						
						setLocalities={actions.setLocalities}						
						setSamplingPoints={actions.setSamplingPoints}
						keywords={domains.keywords.list} 
						setKeywords={actions.setKeywords} 
						layers={explorer.layers}
						getMapLayers={actions.getMapLayers}
						changeOneMapLayer={actions.changeOneMapLayer}
						isFetchingMapLayers={explorer.isFetchingMapLayers}
						maplayers={explorer.maplayers}
						addLayer={actions.addLayer}
						removeLayer={actions.removeLayer}
						moveLayer={actions.moveLayer}
						resetLayers={actions.resetLayers}
						getMapLayerCapabilities={actions.getMapLayerCapabilities}
						zoomToLayer={this.zoomToLayer.bind(this)}
						setShowLegend={actions.setShowLegend}
						showLegend={explorer.showLegend}
						filter={explorer.filter}
						projects={this.props.projects} 
						isGisOnly={this.props.isGisOnly}
						isGisAdmin={this.props.isGisAdmin}
						/> 
					: null}
				{this.state.mapLoaded && !this.props.isGisOnly
					? (<DocumentControl
						documents={this.filterByProject(
							this.filterDocuments(explorer.documents, selectedShapes, selectedKeywords, explorer.filter.ids))}
						selected={explorer.selected}
						isFetching={explorer.isFetching} 
						getDocumentDetails={this.props.getDocumentDetails}
						getDocumentFiles={this.props.getDocumentFiles}
						resetSelection={this.props.actions.setExplorerSelectedDocuments}
						downloadFile={this.props.downloadFile}
						hideDocumentsFromMap={this.props.hideDocumentsFromMap}
						setHideDocumentsFromMap={this.props.actions.setHideDocumentsFromMap}
					/>)
					: null}

				{typeof this.drawingManager !== "undefined" && this.state.showDelete
					? <DeleteRect onClick={() => this.removeOverlay()} /> : null
				}
				{explorer.showLegend 
					? <Legend layers={explorer.layers} top={this.state.legendTop} left={this.state.legendLeft} /> 
					: null}

				{this.renderGallery()}
			</div>
		);
	}
}

Explorer.propTypes = {
	actions: PropTypes.object.isRequired,
	explorer: PropTypes.object.isRequired,	
	groupedShapes: PropTypes.object.isRequired,
	groupedTitles: PropTypes.object.isRequired,
	groupedDocuments: PropTypes.object.isRequired,
	selectedShapes: PropTypes.array.isRequired,
	selectedKeywords: PropTypes.array.isRequired,
	domains: PropTypes.object.isRequired,
	getDocumentDetails: PropTypes.func.isRequired,
	getDocumentFiles: PropTypes.func.isRequired,
	getGeom: PropTypes.func.isRequired,
	getShapes: PropTypes.func.isRequired,
	getKeywords: PropTypes.func.isRequired,
	downloadFile: PropTypes.func.isRequired,
	connectDropTarget: PropTypes.func.isRequired,
	userProjectAccess: PropTypes.array.isRequired,
	projects: PropTypes.object.isRequired,
	hideDocumentsFromMap: PropTypes.bool.isRequired,
	isGisOnly: PropTypes.bool.isRequired,
	isGisAdmin: PropTypes.bool.isRequired
};

const legendTarget = {
	drop(props, monitor, component) {
		const item = monitor.getItem();
		const delta = monitor.getDifferenceFromInitialOffset();
		const left = Math.round(item.left + delta.x);
		const top = Math.round(item.top + delta.y);

		component.moveLegend(left, top);
	}
};

export default DropTarget("LEGEND", legendTarget, connect => ({
	connectDropTarget: connect.dropTarget()
}))(Explorer);


// WEBPACK FOOTER //
// ./src/components/Explorer/Explorer.js